/**************************************************************************************************/
/*   File: /src/app/stores/states/details/state.ts                                                 */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Tuesday February 19th 2019                                                     */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Apr 19 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { DossierId } from '../../../shared/models/dossier.id';
import { Message } from '../../../shared/models/message';
import { DossierStatus } from '../../../shared/models/dossier.status';
import { Dossier, FileModel } from '../../../shared/models';
/**
 * The dossier details state
 */
export interface DetailsState {
  /**
   * The id
   * @type {DossierId}
   */
  dossierId: DossierId;
  /**
   * The dossier detail
   * @type {DossierDetails}
   */
  dossier: Dossier;
  /**
   * The dossier status
   * @type {DossierStatus}
   */
  dossierStatus: DossierStatus;
  /**
   * The messages array
   * @type {Message[]}
   */
  messages: Message[];
  /**
   * Is validating flag
   * @type {boolean}
   */
  isValidating: boolean;
  /**
   * Is validated flage
   * @type {boolean}
   */
  isValidated: boolean;
  /**
   * Is loaded flag
   * @type {boolean}
   */
  isLoaded: boolean;
  /**
   * IsLoading flag
   * @type {boolean}
   */
  isLoading: boolean;
}

/**
 * The initial dossier details state
 */
export const INITIAL_DOSSIER_DETAILS_STATE: DetailsState = {
  dossierId: undefined,
  dossier: undefined,
  dossierStatus: undefined,
  messages: [],
  isValidating: false,
  isValidated: false,
  isLoaded: false,
  isLoading: false
};

/**
 * The state name
 */
export const STATE_NAME = 'details';